import { useQuery } from '@tanstack/react-query';

import { teamApi } from '../api';
import {
  TEAM_SHARED_TASKS_QUERY_KEY,
  TeamTasksResult,
  normalizeTeamTaskItem,
} from './teamTasks.shared';

interface UseSharedTeamTasksParams {
  userId: string;
  teamId?: string;
  date?: string;
}

export const useSharedTeamTasks = ({ userId, teamId, date }: UseSharedTeamTasksParams) => {
  const teamTasksQuery = useQuery({
    queryKey: [...TEAM_SHARED_TASKS_QUERY_KEY, { userId, teamId, date }],
    queryFn: () => {
      return teamApi.getTeamTasks(teamId!, date!).then(({ data }) => {
        return {
          date: data.date,
          counts: data.counts,
          tasks: (data.tasks ?? []).map(normalizeTeamTaskItem).filter(Boolean),
        } as TeamTasksResult;
      });
    },
    refetchOnWindowFocus: false,
    enabled: !!userId && !!teamId && !!date,
    staleTime: 5000,
  });

  return {
    teamTasks: teamTasksQuery.data ?? null,
    tasks: teamTasksQuery.data?.tasks ?? [],
    counts: teamTasksQuery.data?.counts ?? null,
    ...teamTasksQuery,
  };
};
